export function toggleSelection(list, value, checked) {
  if (checked) {
    return list.includes(value) ? list : [...list, value];
  }
  return list.filter(item => item !== value);
}
